import React from "react";
import Hero from "../../Component/Hero/Hero";
import State from "../../Component/Hero/State";
import WhyMedmyne from "../../Component/Hero/WhyMedmyne";
import MediaGallery from "../../Component/Hero/MediaGallery";
import Team from "../../Component/Hero/Team";
import DoctorReviews from "../../Component/Hero/DoctorReviews";
import HowDoesItWork from "../../Component/HowDoesItWork/HowDoesItWork";
import AboutMedmine from "../../Component/AboutMedmine/AboutMedmine";
import PatientReview from "../../Component/PatientReview/PatientReview";

const Home = () => {
  return (
    <div className="">
      <Hero />
      <State />
      <WhyMedmyne />
      <AboutMedmine />
      <Team color={"bg-white"} />
      <DoctorReviews />
      <HowDoesItWork />
      <PatientReview />
      {/* <DeveloperTeam /> */}
    </div>
  );
};

export default Home;
